// B-Design only applies style to Loading component.
import Spin from 'antd/es/spin';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(Spin);
